import { useState } from "react"

export default () => {
  const [seatingActive, setSeatingActive] = useState(false)
  const [seatingProduct, setSeatingProduct] = useState()

  return {seatingActive, setSeatingActive, seatingProduct, setSeatingProduct}
}
